/**
 * Registration agreement copy and version.
 * Bump REGISTRATION_AGREEMENT_VERSION whenever disclosure text changes.
 */
export const REGISTRATION_AGREEMENT_VERSION = '2026-07-04-v1';

export const REGISTRATION_AGREEMENT = {
  independence: {
    title: 'Independencia de GFI Latino',
    body:
      'GFI Latino es un movimiento independiente, no oficialmente afiliado ni operado por GFI. ' +
      'Los miembros están licenciados o contratados de forma independiente con GFI.',
  },
  recordingCompliance: {
    title: 'Cumplimiento sobre grabaciones del Training Room',
    body:
      'Por respeto al presentador, el miembro acepta mantenerse en pleno cumplimiento con GFI y no compartir ' +
      'contenido de video del Training Room, en parte o en su totalidad, en redes sociales.',
  },
  agentCodeNote:
    'Tu Código de Agente será verificado periódicamente contra los registros de GFI para mantener tu cuenta activa.',
  acceptanceLabel:
    'He leído y acepto las declaraciones de independencia y cumplimiento sobre grabaciones anteriores.',
};
